export default __webpack_public_path__ + "static/side-navigation.light-8f87db680fcd77d2359c60e51ae1d70ac81dd2c86cf793fd0395dc3073c86060.png";